module.exports = __webpack_public_path__ + "static/media/hero.cb542f1c.jpg";